import React, { Component } from 'react';
import groupBy from 'lodash/groupBy';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchProductDetails } from '../../store/actions/product.actions';
import UniversalLinkContainer from './UniversalLink';

export class Sitemap extends Component {
  renderLinks(links) {
    return links.map(({
      sku,
      href,
      anchor,
      type,
    }) => (!sku ? (
      <li className="sitemap-group-site-link" key={href}>
        <UniversalLinkContainer
          to={href}
          label={anchor}
          location="sitemap"
          type={type || 'Page'}
        >
          {anchor}
        </UniversalLinkContainer>
      </li>
    ) : (
      <li className="sitemap-group-product-link" key={sku} onClick={() => this.props.fetchProductDetailsAction({ sku })}>
        {anchor}
      </li>
    )));
  }

  renderSiteMapGroups(sitemap) {
    const siteMapByGroup = groupBy(sitemap, 'text');
    return Object.entries(siteMapByGroup).map(([group, linksInGroup]) => (
      <div
        className="sitemap-group"
        data-testid={`sitemap-${group}`}
        key={group}
      >
        <h4>{group}</h4>
        <ul>
          {this.renderLinks(linksInGroup)}
        </ul>
      </div>
    ));
  }

  render() {
    const { links } = this.props;
    return (
      <>
        <div className="sitemap">
          {this.renderSiteMapGroups(links)}
        </div>
      </>
    );
  }
}

Sitemap.defaultProps = {
  links: [],
};

Sitemap.propTypes = {
  links:PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    sku: PropTypes.string,
    href: PropTypes.string.isRequired,
    anchor: PropTypes.string.isRequired,
  })),
};

const mapDispatchToProps = {
  fetchProductDetailsAction: fetchProductDetails,
};

export default connect(null, mapDispatchToProps)(Sitemap);
